export const ACADEMY_LEAD = 'academy_lead';
export const INTENSIVE_LEAD = 'intensive_lead';

export const LEAD_CATEGORY = 'lead_category';

export const WEBINAR1DATE_AND_TIME = 'webinar1DateTime';

export const otpFieldConstants = {
  timerWithResendOtp: 'TIMER_WITH_RESEND_OTP',
  timerAwayFromResendOtp: 'TIMER_AWAY_FROM_RESEND_OTP'
};

export const otpFieldTypeConstants = {
  sixDigitInputBoxes: 'SIX_DIGIT_INPUT_BOXES'
};

export const OTP_INPUT_BOXES = 6;
